const DocumentResearchStatus = Object.freeze({
    CREATED: 'created',
    DISCOVERY_DISPATCH_PENDING: 'discovery_dispatch_pending',
    DISCOVERY_PENDING: 'discovery_pending',
    DISCOVERY_REVIEW_REQUIRED: 'discovery_review_required',
    DISCOVERY_FAILED: 'discovery_failed',
    AWAITING_DOCUMENT_SELECTION: 'awaiting_document_selection',
    MATERIALIZATION_PENDING: 'materialization_pending',
    ANALYSIS_DISPATCH_PENDING: 'analysis_dispatch_pending',
    ANALYSIS_PENDING: 'analysis_pending',
    REVIEW_DISPATCH_PENDING: 'review_dispatch_pending',
    REVIEW_PENDING: 'review_pending',
    COMPLETED: 'completed',
    COMPLETED_EMPTY: 'completed_empty',
    REJECTED: 'rejected',
    FAILED: 'failed',
    UNAVAILABLE: 'unavailable',
})

const ACTIVE_STATUSES = Object.freeze([
    DocumentResearchStatus.CREATED,
    DocumentResearchStatus.DISCOVERY_DISPATCH_PENDING,
    DocumentResearchStatus.DISCOVERY_PENDING,
    DocumentResearchStatus.MATERIALIZATION_PENDING,
    DocumentResearchStatus.ANALYSIS_DISPATCH_PENDING,
    DocumentResearchStatus.ANALYSIS_PENDING,
    DocumentResearchStatus.REVIEW_DISPATCH_PENDING,
    DocumentResearchStatus.REVIEW_PENDING,
])

const ACTION_REQUIRED_STATUSES = Object.freeze([
    DocumentResearchStatus.DISCOVERY_REVIEW_REQUIRED,
    DocumentResearchStatus.AWAITING_DOCUMENT_SELECTION,
])

const TERMINAL_STATUSES = Object.freeze([
    DocumentResearchStatus.COMPLETED,
    DocumentResearchStatus.COMPLETED_EMPTY,
    DocumentResearchStatus.REJECTED,
    DocumentResearchStatus.FAILED,
])

const isActiveDocumentResearchStatus = status => ACTIVE_STATUSES.includes(status)
const isActionRequiredDocumentResearchStatus = status => (
    ACTION_REQUIRED_STATUSES.includes(status)
)
const isTerminalDocumentResearchStatus = status => TERMINAL_STATUSES.includes(status)
const blocksDocumentResearchCompletion = status => (
    isActiveDocumentResearchStatus(status)
    || isActionRequiredDocumentResearchStatus(status)
)

export {
    ACTIVE_STATUSES,
    ACTION_REQUIRED_STATUSES,
    blocksDocumentResearchCompletion,
    DocumentResearchStatus,
    isActionRequiredDocumentResearchStatus,
    isActiveDocumentResearchStatus,
    isTerminalDocumentResearchStatus,
    TERMINAL_STATUSES,
}
